/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from "@irian-ro/abstract-resource";
import {FormControl, FormGroup} from "@angular/forms";
import {SubscriptionLegalEntityDtoModel} from "./subscription-legal-entity-dto.model";

export class SubscriptionDtoModel extends JSONable {

  uuid : string | undefined = undefined;

  subscriptionTypeUuid: string | undefined = undefined;

  validFrom: string | undefined = undefined;

  validTo: string | undefined = undefined;

  legalEntity: SubscriptionLegalEntityDtoModel | undefined = undefined;

  static createForm() {
    return new FormGroup({
      uuid: new FormControl(null),
      subscriptionTypeUuid: new FormControl(null),
      legalEntity: SubscriptionLegalEntityDtoModel.createForm()
    })
  }

}
